package views.coletor

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import ffSpan
import kotlinx.browser.document
import kotlinx.dom.clear
import lbTitulo
import model.Produtolote
import ffMsgAviso
import org.jetbrains.compose.web.attributes.onSubmit
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Form
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.HTMLDivElement
import utils.*
import utils.ff.Companion.println0
import views.componentes.*

class col008 {

    private val _t = "col008"
    private var lista: List<Produtolote>? = null

    fun show() {

        ffMsgAviso("")
        lbTitulo!!.innerText = "008 - Produtos com divergência no saldo"

        val htmlDiv1 = document.getElementById("htmlDiv1") as HTMLDivElement
        htmlDiv1.clear()
        //htmlDiv1 = document.getElementById("htmlClear") as HTMLDivElement
        //htmlDiv1 = document.getElementById("htmlClear") as HTMLDivElement


        renderComposable(rootElementId = "htmlDiv1") {
            body()
        }

    }

    @Composable
    fun body() {


        //table-responsive-sm
        Form(action = "#", attrs = { classes("table-responsive-sm"); onSubmit { it.preventDefault() } })
        {
            val _table1Controler = remember { mutableStateOf(gsInput(_t)) }

            ffSpan("Lista de produtos com divergência do saldo versus saldo de lote")

            produtoLote(_table1Controler)

            if (!_table1Controler.json().equals("")) {
                Div({ classes("table-responsive-sm") }) {
                    //println0("zuza999")
                    println0(_table1Controler.json().equals(""))
                    //val o = lista.unsafeCast<Array<dynamic>>()
                    //println0(o)

                    val lcon = ArrayList<table1>()
                    lcon.add(table1().add(50, "S", "N", "OO_PRODUTO       ", "Produto"))
                    lcon.add(table1().add(20, "N", "N", "EST_SALDO00      ", "Saldo"))
                    lcon.add(table1().add(20, "N", "N", "PROLOT_SALDO     ", "Soma lote"))
                    lcon.add(table1().add(20, "N", "N", "DIF_SALDO00      ", "Dif."))

                    table1().ffTable1(
                        lcon,
                        _table1Controler = _table1Controler,
                        //_arrayDynamic = lista as Array<dynamic>,
                        _tbTipo = "Mesclado"
                    )
                    if (lista != null && _table1Controler.clickObj() >= 0) {
                        val onot = lista!!.get(_table1Controler.clickObj())
                        val sProduto = onot.PROLOT_PRODUTO.toString()
                        ff().ffLocalizarProduto(sProduto)
                        //col001().show(sProduto)
                        _table1Controler.clickObjLimpar()
                    }
                }
            }
            //ffJS("<script>\"use strict\";</script>")
        }
        //ffJavaScript()
        //ffJS("use strict")

    }

    fun produtoLote(_table1Controler: MutableState<String>) {

        Produtolote().getProdutoLote(0) { _lista ->
            lista = _lista
            _table1Controler.json(JSON.stringify(lista).ffJsonParse(true))
            println0(lista)
        }

    }

}